import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ScheduleDocumentService } from 'src/app/Service/scheduledocument/scheduleDocument.service';
import { WorkflowTemplateModel } from 'src/app/ViewModel/WorkflowTemplateModel';
import { IDeleteWorkflowInputModel } from 'src/app/ViewModel/ScheduleDocumentModel';
import { CommonService } from 'src/app/Service/Common.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { FileUploadLibrary } from 'src/app/Service/file/file.service';

@Component({
  selector: 'app-schedule-workflowhistory',
  templateUrl: './schedule-workflowhistory.component.html',
  styleUrls: ['./schedule-workflowhistory.component.css']
})
export class ScheduleWorkflowhistoryComponent implements OnInit {

  dciToWorkflowHistory: any;
  getworkflowHistoryvalue!: any[];
  workflowList: WorkflowTemplateModel[] = [];
  rowsCount!: number;
  pageSize = 10;
  public enableFilter = false;
  public enableFullscreen = false;
  public SerialNo!: number;
  public FromDeleteDocument: boolean = false;
  public user_id!: number;
  public projectid!: number;

  constructor(public _dialogRef: MatDialogRef<ScheduleWorkflowhistoryComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private ScheduleDocumentService: ScheduleDocumentService, private commonService: CommonService, private _notificationService: NotificationService, private dialog: MatDialog,) {
    if (!!this.data && !!this.data.documentId) {
      this.data["doc_Id"] = this.data.documentId;
      this.dciToWorkflowHistory = this.data;
    } else {
      this.dciToWorkflowHistory = this.data;
    }
    if (this.data && this.data.FromDeleteDocument)
      this.FromDeleteDocument = this.data.FromDeleteDocument;
  }

  async ngOnInit() {
    this.workflowList = await this.ScheduleDocumentService.GetWorkflowList().toPromise();
    this.user_id = this.commonService.getLoggedInUserId();
    this.projectid = this.commonService.getProjectId();
    this.populateGrid();
  }

  closeDialog() {
    this._dialogRef.close();
  }

  populateGrid() {
    this.ScheduleDocumentService.getWorkflowHistory(this.dciToWorkflowHistory.doc_Id).subscribe(data => {
      data.forEach((element: any, i: number) => {
        element.actionPerformedName = element.actionPerformedName.replace(/\s/g, "");
        let value = element.actionPerformedName.split(',');
        data[i]["actionPerformedDisplayName"] = value;
        let splitTxt = element.taskName.split(" ");
      });
      this.getworkflowHistoryvalue = data;
      this.rowsCount = this.getworkflowHistoryvalue.length;
    });
  }

  public viewAttachmentClick() {
    if(this.getworkflowHistoryvalue[0].schedule_Type == 3)
    {
      this.dialog.open(FileListComponent, {
        panelClass: ['mat-dialog-secondary', 'w80'],
        data: { projectId: this.projectid, docId: this.getworkflowHistoryvalue[0].documentId, revisionNo: this.getworkflowHistoryvalue[0].revisionNumber, libraryName: [FileUploadLibrary.WorkflowDocument, FileUploadLibrary.SignedDocuments], createdBy: this.user_id, isDeleteEnable: false, documentNo: this.getworkflowHistoryvalue[0].documentNumber },
      });
    }
    else
    {
      this.dialog.open(FileListComponent, {
        panelClass: ['mat-dialog-secondary', 'w80'],
        data: { projectId: this.projectid, docId: this.getworkflowHistoryvalue[0].documentId, revisionNo: null, libraryName: [FileUploadLibrary.WorkflowDocument, FileUploadLibrary.SignedDocuments], createdBy: this.user_id, isDeleteEnable: false, documentNo: this.getworkflowHistoryvalue[0].documentNumber },
      });
    }
  }

  public viewstepAttachmentClick(dataItem: any) {
    if(dataItem.integration_Type == "DTN Preparation" && dataItem.schedule_Type !=3 )
    {
      this.dialog.open(FileListComponent, {
        panelClass: ['mat-dialog-secondary', 'w80'],
        data: { projectId: this.projectid, docId: dataItem.documentId, revisionNo: dataItem.revisionNumber, libraryName: FileUploadLibrary.SignedDocuments, createdBy: this.user_id, isDeleteEnable: false, documentNo: dataItem.documentNumber },
      });
    }
    else {
      this.dialog.open(FileListComponent, {
        panelClass: ['mat-dialog-secondary', 'w80'],
        data: { projectId: this.projectid, docId: dataItem.documentId, revisionNo: dataItem.revisionNumber, libraryName: FileUploadLibrary.WorkflowDocument, createdBy: this.user_id, isDeleteEnable: false, documentNo: dataItem.documentNumber, task_SNo: dataItem.taskSerialNumber },
      });
    }
  }

  getWorkflowName(workflowId: number) {
    let workflow = this.workflowList.find(x => x.workflowId == workflowId);
    if (!!workflow)
      return workflow.workflowDescription;
    return "";
  }

  checkGridHeight() {
    if (this.getworkflowHistoryvalue.length > 0)
      return 350;
    else
      return 182;
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  DeleteOrUpdateWorkflow(tran_Type: string) {
    if (tran_Type == 'Delete' && !this.SerialNo) {
      this._notificationService.showToast('Please Enter Step.Id', 'Warning');
      return;
    }

    let input: IDeleteWorkflowInputModel = {
      doc_id: this.dciToWorkflowHistory.doc_Id,
      task_sl_no: (tran_Type == 'Update') ? 0 : this.SerialNo,
      tran_type: tran_Type,
      user_id: this.user_id
    }

    let inputforCheck: IDeleteWorkflowInputModel = {
      doc_id: this.dciToWorkflowHistory.doc_Id,
      task_sl_no: this.SerialNo,
      tran_type: 'Check',
      user_id: this.user_id
    }

    this.ScheduleDocumentService.DeleteOrUpdateWorkflow(inputforCheck).subscribe((res: StandardOutputModel) => {
      if (res.successCode == 200) {
        this.ScheduleDocumentService.DeleteOrUpdateWorkflow(input).subscribe((res: StandardOutputModel) => {
          if (res.successCode == 200) {
            this._notificationService.showToast(res.successMessage, "Success");
            this.populateGrid();
          }
        });
      } else if (res.successCode == 201) {
        this._notificationService.showPopup(res.successMessage, 'Confirm').then(data => {
          if (data == 'yes') {
            this.ScheduleDocumentService.DeleteOrUpdateWorkflow(input).subscribe((res: StandardOutputModel) => {
              if (res.successCode == 200) {
                this._notificationService.showToast(res.successMessage, "Success");
                this.populateGrid();
              }
            });
          }
        });
      }
      else {
        this._notificationService.showToast(res.successMessage, "Warning");
      }
    });
  }

}
